import { API, standardResponse } from "./middleware";

export async function sendEmailOTP(email) {
  const url = "/api/auth/sendEmailOTP";
  const params = { email };
  let dataReceive = {};
  await API.post(url, params)
    .then((response) => {
      dataReceive = response.data;
      // return response;
    })
    .catch((error) => standardResponse(false, error.response?.data));
  return dataReceive;
}
export async function validateOtp(email, code) {
  const url = "/api/auth/validateOtp";
  const params = { email, code };
  let dataReceive = {};
  await API.post(url, params)
    .then((response) => {
      dataReceive = response.data;
      // return response;
    })
    .catch((error) => standardResponse(false, error.response?.data));
  return dataReceive;
}
